/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/lib/auth';
import { getSidebarItems, isNavActive } from './navItems';

/** Desktop sidebar (≥lg). Extracted from AppShell.jsx (Code Quality refactor). */
export const SideNav = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const items = getSidebarItems(user);
  return (
    <aside className="hidden lg:flex flex-col gap-1 w-[240px] sticky top-20 self-start" data-testid="sidebar-navigation" aria-label={t('a11ySecondaryNav', 'Navigazione secondaria')}>
      {items.map(({ key, path, labelKey, Icon }) => {
        const active = isNavActive(location.pathname, path);
        return (
          <button
            key={key}
            onClick={() => navigate(path)}
            data-testid={`sidebar-navigation-item-${key}`}
            aria-current={active ? 'page' : undefined}
            className={`flex items-center gap-3 px-4 py-2.5 rounded-full text-sm font-medium transition-colors ${active ? 'bg-primary/10 text-primary' : 'text-foreground hover:bg-secondary'}`}
          >
            <Icon className="h-5 w-5" aria-hidden="true" />
            <span>{t(labelKey)}</span>
          </button>
        );
      })}
    </aside>
  );
};
